/**
 * Created by pandemio on 8/26/18.
 */
import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faChild } from '@fortawesome/free-solid-svg-icons';
/** End of Multiple Language imports **/

/**
 * To handle the child policy
 */
class ModalChildPolicy extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };

        this.toggle = this.toggle.bind(this);
    }

    /**
     * Hide or shows the window
     */
    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
        return (
            <div>
                <span className="red-text" onClick={this.toggle}  style={{textDecoration: "underline"}}>
                    <FontAwesomeIcon icon={faChild}/>{' '}<Translate id="children-policy.title"/>
                </span>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className="modal-results">
                    <ModalHeader toggle={this.toggle}>
                        <Translate id="children-policy.title"/>
                    </ModalHeader>
                    <ModalBody>
                        <span>
                            <Translate>{({translate}) => <span>{translate("children-policy.conditions",  null, { renderInnerHtml: true })}</span>}</Translate>
                        </span>
                     </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.toggle} color="info">
                            <Translate>{({translate}) => <span>{translate("children-policy.close")}</span>}</Translate>
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
export default  ModalChildPolicy;